function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var CalcMath = /*#__PURE__*/function (_React$Component) {
  function CalcMath(props) {
    var _this;
    _classCallCheck(this, CalcMath);
    _this = _callSuper(this, CalcMath, [props]);
    _this.state = {
      yards: false,
      tons: false,
      type: 'asphalt',
      width: '',
      length: '',
      depth: ''
    };
    _this.type = _this.type.bind(_this);
    _this.calc = _this.calc.bind(_this);
    _this.handleOnChange = _this.handleOnChange.bind(_this);
    _this.handleOnBlur = _this.handleOnBlur.bind(_this);
    return _this;
  }
  _inherits(CalcMath, _React$Component);
  return _createClass(CalcMath, [{
    key: "toggle",
    value: function toggle() {
      $('.calc-math').css({
        'height': $('.calc-math').height() === 60 ? 510 : 60
      });
      $('.calc-math__icon--calculator').css({
        'display': $('.calc-math').height() === 60 ? 'none' : 'block'
      });
      $('.calc-math__icon--x').css({
        'display': $('.calc-math').height() === 60 ? 'block' : 'none'
      });
    }
  }, {
    key: "type",
    value: function type(_type) {
      var self = this;
      this.setState({
        type: _type
      }, function () {
        self.calc();
      });
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(type, e) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
      if (e.target.value.split('.').length - 1 > 1) return;
      var amount = e.target.value.split('.');
      if (amount.length === 2 && amount[1].length > 1) return;
      this.setState(_defineProperty({}, type, e.target.value));
    }
  }, {
    key: "handleOnBlur",
    value: function handleOnBlur(type, e) {
      if (e.target.value === '.') e.target.value = '';else {
        var amount = e.target.value.split('.');
        if (amount.length === 1) {
          if (amount[0].length === 0) amount[0] = '0';
          e.target.value = amount[0] + '.0';
        } else if (amount.length === 2) {
          if (amount[0].length === 0) amount[0] = '0';
          if (amount[1].length === 0) amount[1] = '0';
          // else if (amount[1].length === 1)
          // 	amount[1] = amount[1];

          e.target.value = amount[0] + '.' + amount[1];
        }
      }
      if (parseFloat(e.target.value) === 0) e.target.value = '';
      this.handleOnChange(type, e);
    }
  }, {
    key: "formatInput",
    value: function formatInput(val) {
      if (val.length === 1 && val[0] === '0') return '';
      val = val.replace(/[^0-9]/g, '');
      return val;
    }
  }, {
    key: "calc",
    value: function calc() {
      var _this$state = this.state,
        type = _this$state.type,
        width = _this$state.width,
        length = _this$state.length,
        depth = _this$state.depth;
      var yd = width * length * (depth / 12) / 27;
      var total = type === 'asphalt' ? 2 : 1.5;
      $('#calc-math-yd').text(yd.toFixed(2) + ' yd/tn');
      $('#calc-math-tn').text((yd * total).toFixed(2) + ' cu/tn');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        type = _this$state2.type,
        width = _this$state2.width,
        length = _this$state2.length,
        depth = _this$state2.depth;
      return /*#__PURE__*/React.createElement("div", {
        className: "calc-math"
      }, /*#__PURE__*/React.createElement("div", {
        className: "calc-math__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "calc-math__header",
        onClick: this.toggle
      }, /*#__PURE__*/React.createElement("img", {
        className: "calc-math__icon calc-math__icon--calculator",
        src: "/public/images/calculator.png"
      }), /*#__PURE__*/React.createElement("img", {
        className: "calc-math__icon calc-math__icon--x",
        src: "/public/images/calculator-x.png"
      }), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__header--label"
      }, "MATERIALS", /*#__PURE__*/React.createElement("br", null), "CALCULATOR")), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__hr"
      }), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__type"
      }, "CHOOSE PRODUCT TYPE"), /*#__PURE__*/React.createElement("div", {
        className: 'calc-math__option calc-math__option--asphalt ' + (type === 'asphalt' ? 'calc-math__option--selected' : ''),
        onClick: this.type.bind(this, 'asphalt')
      }, "ASPHALT"), /*#__PURE__*/React.createElement("div", {
        className: 'calc-math__option calc-math__option--non-asphalt ' + (type === 'non-asphalt' ? 'calc-math__option--selected' : ''),
        onClick: this.type.bind(this, 'non-asphalt')
      }, "NON-ASPHALT"), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__hr"
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: "ENTER WIDTH",
        value: width,
        onChange: this.handleOnChange.bind(this, 'width'),
        onBlur: this.handleOnBlur.bind(this, 'width')
      }), "FEET"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: "ENTER HEIGHT",
        value: length,
        onChange: this.handleOnChange.bind(this, 'length'),
        onBlur: this.handleOnBlur.bind(this, 'length')
      }), "FEET"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: "ENTER DEPTH",
        value: depth,
        onChange: this.handleOnChange.bind(this, 'depth'),
        onBlur: this.handleOnBlur.bind(this, 'depth')
      }), "INCHES"), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__calculate",
        onClick: this.calc
      }, "CALCULATE"), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result"
      }, /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result--label"
      }, "TOTAL CUBIC YARDS*"), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result--nr",
        id: "calc-math-yd"
      }, "\xA0")), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result"
      }, /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result--label"
      }, "TOTAL TONS*"), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__result--nr",
        id: "calc-math-tn"
      }, "\xA0")), /*#__PURE__*/React.createElement("div", {
        className: "calc-math__estimate"
      }, "* The total above are for estimates only. Many factors can impact quantity.")));
    }
  }]);
}(React.Component);
export default CalcMath;